module.exports = __webpack_public_path__ + "img/Rectangle 19header.c1c65490.png";